import React, { useState } from 'react'
import Logo from '../OnboardingRevampPage/Logo'
import { useDispatch, useSelector } from 'react-redux'
import { Line } from 'rc-progress'
import { useEffect } from 'react'
import PricingCard from '../OnboardingRevampPage/PricingCard'
import BenefitsSection from '../OnboardingRevampPage/BenefitsSection'
import ReviewSection from '../OnboardingRevampPage/ReviewSection'
import FAQSection from '../OnboardingRevampPage/FAQSection'
import useWindowSize from '../../hooks/useWindowSize'
import SuccessStoriesSection from '../OnboardingRevampPage/SuccessStoriesSection'
import RecognitionSection from '../OnboardingRevampPage/RecognitionSection'
import { Mixpanel } from '../../config/Mixpanel'
import Constants from '../../common/constants'
import { dispatchUserPersonaliseCourseSelection, fetchPaymentId, fetchRazorPayStatus } from '../../redux/actions/personaliseCourse'
import useRazorpay from 'react-razorpay'
import { RAZORPAY_KEY } from '../../config/api_config'
import { useNavigate } from 'react-router-dom'
import GraphSection from '../OnboardingRevampPage/GraphSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/free-regular-svg-icons'
import LearntubeStatsSection from '../OnboardingRevampPage/LearntubeStatsSection'
import OurLearnersWorkAt from '../../components/Carousel'
import BottomEvenPersonaliseSection from './BottomEvenPersonalisationSection'
import './index.css'
import { useSearchParams } from "react-router-dom";

const cradFeatures = [
    "Industry-Verified Certification",
    "Lifetime Access to 3100+ More Courses",
    "Live Doubt Solving"
]

const PersonalisedAnalysis = () => {

    const userName = useSelector(state => state.profileDetails?.name)
    const skillName = useSelector(state => state.personaliseCourse?.skill_name)
    const skillslug = useSelector(state => state.personaliseCourse?.skill_slug)
    const analysis = useSelector(state => state.personaliseCourse?.analysis)
    const skillDetails = useSelector(state => state.personaliseCourse?.skillDetails)
    const score = useSelector(state => state.personaliseCourse?.score)
    const email = useSelector(store => store?.profileDetails?.email)
    const uuid = useSelector(state => state?.personaliseCourse?.UUID)
    const phoneNumber = useSelector(state => state?.profileDetails?.['phone-number'])
    const rank = useSelector(state => state?.personaliseCourse?.rank)
    const onboardingData = useSelector(state => state?.personaliseCourse?.onboardingData)
    const customisedSkill = useSelector(state => state.personaliseCourse?.customSkillSelected)

    const [ userWrong, setUserWrong ] = useState([])
    
    const { width } = useWindowSize()
    const dispatch = useDispatch()
    const Razorpay = useRazorpay()
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()

    useEffect(() => {
        Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_ANALYSIS, {
            distinct_id: email
        })
        setUserWrong(analysis?.user_weak_areas?.split("\n")?.filter?.((item) => (
            item?.length > 0
        )))
    }, [])

    const razorpayHandler = ((callback) => {
        dispatch(fetchPaymentId(uuid, 199, "Personalise Course", successObj => {
            const options = {
                key: RAZORPAY_KEY,
                amount: `${199*100}`,
                currency: "INR",
                name: skillName,
                description: "Personalise Course",
                order_id: successObj?.razorpay_order_id,
                modal: {
                  "ondismiss": function () {
                    callback()
                  }
                },
                handler: (res) => {
                  getOrderStatusSuccess(res)
                  callback();
                },
                prefill: {
                  name: userName,
                  email: email,
                  contact: phoneNumber,
                },
                // notes: {
                //     address: "Razorpay Corporate Office"
                // },
                theme: {
                  color: "#26CBA7"
                }
            }
            const razorpayInitializor = new Razorpay(options)
            razorpayInitializor.on("payment.failed", function (response) {
                getOrderStatusFailure(response)
                callback()
            })
            razorpayInitializor.open()
        }))
    })

    const getOrderStatusSuccess = async (response) => {
        await dispatch(fetchRazorPayStatus({
            uuid: uuid,
            payment_id: response?.razorpay_payment_id,
            order_id: response?.razorpay_order_id,
            isError: false,
            razorpay_signature: response?.razorpay_signature,
            errorObj: {}
        }))
        await dispatch(dispatchUserPersonaliseCourseSelection(true))
        window.location.href = `https://personalise.learntube.ai/onboarding/loader-2?skill_slug=${skillslug}&uuid=${uuid}&email=${email}&name=${userName}&skill_level=${skillDetails?.skill}`
    }
    
    const getOrderStatusFailure = async (response) => {
        dispatch(fetchRazorPayStatus({
            uuid: uuid,
            payment_id: response?.error?.metadata?.payment_id,
            order_id: response?.error?.metadata?.order_id,
            isError: true,
            razorpay_signature: "",
            errorObj: { ...response?.error }
        }))
    }

    const handleSkip = () => {
        if (customisedSkill){
            if(searchParams.get("course")){
                navigate(`/popular-course/${searchParams?.get("course")}`);
              }
              else{
         navigate('/courses')}
              
        }else{
            navigate(`/${onboardingData.course_slug}/${onboardingData.skill_slug}/${onboardingData.mskill_slug}/${onboardingData.id}`)
        }
    }
    
    return (
        <div className='min-h-screen text-white parent-radial-gradient-background'>
            <div className='absolute z-50 top-5 md:top-8 right-6 md:right-10 cursor-pointer' onClick={() => {
                Mixpanel.track(Constants.Mixpanel.PERSONALISE_PAGE_SKIP)
                handleSkip()}}
            >
                <p className='text-[#1983D0] underline font-semibold'>Skip</p>
            </div>
            <div className='p-4 md:p-6 md:w-2/3 md:mx-auto'>
                <Logo/>
                <h2 className='text-center text-2xl md:text-[32px] font-semibold mb-4 leading-7 md:leading-9 md:my-8'>{userName?.split(" ")?.[0]}, Here Is Your Analysis For {skillName}</h2>
                <div className='bg-[#2D4F71] rounded-2xl p-4'>
                    <div className='flex items-center justify-between'>
                        <p className='text-sm md:text-xl'>Your Score: <span className={`${score <= 20 ? 'text-[#E06064]' : 'text-[#F59E0B]'} font-bold`}>{score}</span></p>
                        <div className='flex flex-1 justify-center pl-14 md:pl-24'>
                            <p className='text-xs md:text-xl text-left'>Your Skill Level: <span className='text-[#F59E0B] font-bold'>{score <= 20 ? "Newbie" : score <= 50 ? "Amateur" : "Intermediate"}</span></p>
                        </div>
                    </div>
                    <div className='flex justify-between items-center mt-0.5 md:mt-0'>
                        <p className='text-sm md:text-xl'>Your Rank: <span className='text-[#F59E0B] font-bold'>{rank}</span>/731</p>
                        <div className='w-[50%] relative'>
                            <Line strokeWidth={width < 768 ? "3" : "2"} strokeColor='#2BBD13' percent={score+1} trailWidth={width < 768 ? "3" : "2"}/>
                            <div className='w-4 h-4 md:w-5 md:h-5 absolute -top-1.5 md:-top-2' style={{left: `${score}%`}}>
                                <img src="https://assets.learntube.ai/files/AI_Syllabus_generator/Vector.svg?updatedAt=1685338311398" alt="star icon" className='w-full h-full' />
                            </div>
                        </div>
                    </div>
                    <div className='mt-3 md:mt-5'>
                        <h3 className='font-semibold md:text-xl mb-2 md:mb-1'>Your Analysis</h3>
                        {userWrong?.map((item, index) => (
                            <div key={index} className={`flex flex-col bg-[#1D3854] ${index === 0 ? 'rounded-t-xl' : ''} ${index === userWrong?.length - 1 ? 'rounded-b-xl' : ''}`}>
                                <div className='flex items-center p-3'>
                                    <div className='w-[20px] h-auto mr-3'>
                                        <img src="https://assets.learntube.ai/files/Onboarding_Revamp/cross%2021.png?updatedAt=1694700171563" alt="cross icon" className='w-full h-full'/>
                                    </div>
                                    <p className='text-sm text-white w-[85%]'>{item}</p>
                                </div>
                                <div className='w-full h-[2px] bg-[#2D4F71]'/>
                            </div>))
                        }
                    </div>
                </div>
                <div className='mt-6'>
                    <h3 className='text-xl font-semibold mb-2 leading-6 md:mb-4'>Want To Fix These & Be An Expert With A Course Built Just For You?</h3>
                    <PricingCard
                        razorpayHandler={razorpayHandler}
                        onboardingData={onboardingData}
                        handleSkip={handleSkip}
                    />
                    <div className='md:hidden bg-[#2D4F71] rounded-2xl p-4 mt-5'>
                        <p className='font-medium'>What’s Included With Personalised Course</p>
                        <div className='mt-3 w-full'>
                            <img src="https://assets.learntube.ai/files/Onboarding_Revamp/Group%206770.png?updatedAt=1694519221181" alt="demo certificate" className='w-full h-auto'/>
                        </div>
                        <div>
                            {cradFeatures?.map((item, index) => (
                                <div key={index} className='bg-[#1C3956] flex items-center rounded-lg py-2 px-1 mt-2 justify-center'>
                                    <FontAwesomeIcon icon={faCircleCheck} color='#4AAD60'/>
                                    <p className='text-sm ml-2 font-semibold'>{item}</p>
                                </div>
                            ))}
                        </div>

                    </div>
                </div>
                <div className='mt-6 md:mt-8'>
                    <h3 className='text-xl font-semibold mb-2 md:mb-3'>You, Can Change Your Career Now!</h3>
                    <GraphSection/>
                </div>
                <div className='mt-6 md:mt-8'>
                    <h3 className='text-xl font-semibold mb-2 md:mb-3'>Benefits Of Our Personalised Course</h3>
                    <BenefitsSection />
                </div>
                <div className='mt-6 md:mt-8'>
                    <h2 className='text-xl font-semibold mb-2 md:mb-3'>Success Stories</h2>
                    <SuccessStoriesSection />
                </div>
                <div className='mt-5 md:mt-7'>
                    <h2 className='text-xl font-semibold mb-2 md:mb-3'>LearnTube Stats</h2>
                    <LearntubeStatsSection />
                </div>
                <div className='mt-6 md:mt-8'>
                    <h2 className='text-xl font-semibold mb-2 md:mb-3'>Our Learners Really Love Us</h2>
                    <ReviewSection />
                </div>
                <div className='mt-6 md:mt-8'>
                    <h2 className='text-xl font-semibold mb-2 md:mb-3'>Our Learners Work At</h2>
                    <OurLearnersWorkAt/>
                </div>
                <div className='mt-6 md:mt-8'>
                    <h2 className='text-xl font-semibold mb-2 md:mb-3'>Recongised By</h2>
                    <RecognitionSection/>
                </div>
                <div className='mt-6 md:mt-8'>
                    <BottomEvenPersonaliseSection
                        razorpayHandler={razorpayHandler}
                        onboardingData={onboardingData}
                        handleSkip={handleSkip}
                    />
                </div>
                <div className='flex items-center justify-center mt-3'>
                    <div className='w-8 h-8'>
                        <img src="https://assets.learntube.ai/files/Onboarding_Revamp/image%20532.png?updatedAt=1694587310461" className='w-full h-full object-cover'  alt="money back image" />
                    </div>
                    <p className='text-xs md:text-sm ml-1.5'>100% Moneyback Gurantee</p>
                </div>
                <div className='mt-6 md:mt-8'>
                    <h2 className='text-xl font-semibold mb-2 md:mb-3'>Frequently Asked Questions</h2>
                    <FAQSection/>
                </div>
            </div>
        </div>
    )
}

export default PersonalisedAnalysis